import { PARAM_KEYS, PL, STAGES_ORDER, STAGE_FULL, getScoreColor, paramDominance } from "@/lib/reportUtils";

export const ParameterDominance = ({ paramsByStage, scoreScale = 1 }) => {
  const dom = paramDominance(paramsByStage);
  const activeStages = STAGES_ORDER.filter((s) => paramsByStage[s]);
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="param-dominance">
      {activeStages.map((s) => {
        const d = dom[s] || { top: [], bottom: [] };
        return (
          <div key={s} className="border border-[#E0E6E1] rounded-lg p-3 bg-white">
            <p className="text-[11px] font-semibold text-[#1B291D] mb-2">{STAGE_FULL[s]}</p>
            <div className="mb-2">
              <p className="text-[9px] uppercase tracking-wider font-bold text-[#43A047] mb-1">✅ Top 3 Strengths</p>
              {d.top.map((p) => (
                <div key={p.pk} className="flex items-center justify-between text-[10px] py-0.5">
                  <span className="text-[#1B291D] truncate">{PL[p.pk]}</span>
                  <span className="font-semibold ml-2" style={{ color: getScoreColor(p.adj) }}>{(p.adj * scoreScale).toFixed(2)}</span>
                </div>
              ))}
            </div>
            <div className="border-t border-[#E0E6E1] pt-2">
              <p className="text-[9px] uppercase tracking-wider font-bold text-[#D32F2F] mb-1">⚠️ Bottom 3 Weaknesses</p>
              {d.bottom.map((p) => (
                <div key={p.pk} className="flex items-center justify-between text-[10px] py-0.5">
                  <span className="text-[#1B291D] truncate">{PL[p.pk]}</span>
                  <span className="font-semibold ml-2" style={{ color: getScoreColor(p.adj) }}>{(p.adj * scoreScale).toFixed(2)}</span>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
